import React, { FunctionComponent } from 'react'
import {
  getStructuredDataScriptContent,
  StructuredDataInput,
} from 'Shared/utils/structuredData'

interface PuxStructuredDataType {
  structuredData: StructuredDataInput
}

const PuxStructuredData: FunctionComponent<PuxStructuredDataType> = (props) => {
  const structuredDataScriptContent = getStructuredDataScriptContent(
    props.structuredData
  )

  if (!structuredDataScriptContent) {
    return null
  }

  return (
    <script
      type='application/ld+json'
      dangerouslySetInnerHTML={{
        __html: structuredDataScriptContent,
      }}
    />
  )
}

export default PuxStructuredData
